module.exports = __webpack_public_path__ + "static/media/close.70ac6e86.svg";